import statusBannerController from './controllers/statusBanner.controller';
import eventTileController from './controllers/event.tile.controller';
import logInOutController from './controllers/logInOut.controller';
import stopEditingController from './controllers/stopEditing.controller';
import activityRowController from './controllers/activity.row.controller';
import activityAddController from './controllers/activity.add.controller';
import guestInputModalController from './controllers/guest.input.modal.controller';

import statusBannerComponent from './components/statusBanner.component';
import eventTileComponent from './components/event.tile.component';
import logInOutComponent from './components/logInOut.component';
import logInOutMenuComponent from './components/logInOut.menu.component';
import stopEditingComponent from './components/stopEditing.component';
import stopEditingMenuComponent from './components/stopEditing.menu.component';
import activityRowComponent from './components/activity.row.component';
import activityAddComponent from './components/activity.add.component';
import guestInputModalComponent from './components/guest.input.modal.component';

import guestModalService from './services/guest.modal.service';

let widgetModule = angular.module('spabooker.widget', [])
    .controller('statusBannerController', statusBannerController)
    .controller('eventTileController', eventTileController)
    .controller('logInOutController', logInOutController)
    .controller('stopEditingController', stopEditingController)
    .controller('activityRowController', activityRowController)
    .controller('activityAddController', activityAddController)
    .controller('guestInputModalController', guestInputModalController)

    .component('statusBanner', statusBannerComponent)
    .component('eventTile', eventTileComponent)
    .component('logInOut', logInOutComponent)
    .component('logInOutMenu', logInOutMenuComponent)
    .component('stopEditing', stopEditingComponent)
    .component('stopEditingMenu', stopEditingMenuComponent)
    .component('activityRow', activityRowComponent)
    .component('activityAdd', activityAddComponent)
    .component('guestInputModal', guestInputModalComponent)

    .factory('guestModalService', guestModalService)
    ;
export default widgetModule.name;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/index.js